/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ArchiveWalletResponse, ArchiveWalletVars } from '../openapi-types.gen.js';

export type { ArchiveWalletResponse, ArchiveWalletVars } from '../openapi-types.gen.js';

export const useArchiveWallet = createMutationHook<ArchiveWalletVars, ArchiveWalletResponse, unknown>({
  specName: 'useArchiveWallet',
  path: '/v1/wallets/{id}/archive',
  method: 'PATCH',
  resolveUrl: (vars: ArchiveWalletVars) => `/v1/wallets/${vars.id}/archive`,
  
  parseResponse: (raw: unknown): ArchiveWalletResponse => raw as ArchiveWalletResponse,
  
  
  
});
